export const TransType = {
  1: '1x2',
  2: '1x2',
  X12: '1x2',
  CS: 'Correct Score',
  FLG: 'First Goal / Last Goal',
  HDP: 'Handicap',
  HFT: 'Half Time / Full Time',
  OE: 'Odd / Even',
  OU: 'Over / Under',
  OUT: 'Outright',
  PAR: 'Parlay',
  TG: 'Total Goal',
  X: '1x2',
  '1X': 'Double Chance',
  12: 'Double Chance',
  X2: 'Double Chance',
  ETG: 'Exact Total Goals',
  HTG: 'Exact Home Team Goals',
  ATG: 'Exact Away Team Goals',
  HP3: '3 Way Handicap',
  CNS: 'Clean Sheet',
} as Record<string, string>;

export default TransType;
